<mat-list-item [ngClass]="classItem()">
  @if (tooltip() != null) {
    <label matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()"
      [matTooltip]="tooltip()" [class.warn]="checkRequired() || checkValid()">
      <span>{{label()}}</span>
    </label>
  }
  @if (tooltip() == null) {
    <label [class.warn]="checkRequired() || checkValid()">{{label()}}</label>
  }
  @switch (type()) {
    @case ('boolean') {
      <unite-boolean-field [control]="control()" [editIcon]="editIcon()" [checkIcon]="checkIcon()"
        classField="inline-field">
      </unite-boolean-field>
    }
    @case ('energyLabel') {
      <unite-energy-label-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" classField="inline-field">
      </unite-energy-label-field>
    }
    @case ('buildingType') {
      <unite-building-type-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" classField="inline-field">
      </unite-building-type-field>
    }
    @case ('unitType') {
      <unite-building-type-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" [unit]="true" classField="inline-field">
      </unite-building-type-field>
    }
    @case ('buildingPurpose') {
      <unite-building-purpose-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" classField="inline-field">
      </unite-building-purpose-field>
    }
    @case ('buildingStatus') {
      <unite-building-status-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" [ownershipVerified]="ownershipVerified()" classField="inline-field">
      </unite-building-status-field>
    }
    @case ('livingSituation') {
      <unite-living-situation-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" classField="inline-field">
      </unite-living-situation-field>
    }
    @case ('incomeSource') {
      <unite-income-source-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" classField="inline-field">
      </unite-income-source-field>
    }
    @case ('rentalType') {
      <unite-rental-type-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" classField="inline-field">
      </unite-rental-type-field>
    }
    @case ('rentedTo') {
      <unite-rented-to-field [control]="control()" [editIcon]="editIcon()"
        [checkIcon]="checkIcon()" classField="inline-field" [rentalType]="rentalType()">
      </unite-rented-to-field>
    }
    @case ('inline') {
      <ng-content></ng-content>
    }
  }
</mat-list-item>
